import { PROPERTY_STATUS } from 'constants/dbEnums';
import { createIcon } from '@chakra-ui/icons';
import { formatDate } from 'constants/commonFunctions';
import { TRANSACTION_TYPE } from 'constants/dbEnums';
import { AD_TYPE } from 'constants/dbEnums';
import { PROPERTY_TYPE } from 'constants/dbEnums';
import { formatLocation } from 'constants/commonFunctions';
import { JOB_APPLICATION_STATUS } from 'constants/dbEnums';
import { formatTime } from 'constants/commonFunctions';
import randomstring from 'randomstring';
import { PROPERTY_TYPE_META_TAGS } from 'constants/dbEnums';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { USER_ROLE } from 'constants/dbEnums';
import { STATIC_CONTENT_DATA_API } from 'constants/endpoints';
import axios from 'axios';
import { RESIDENTIAL_PROPERTY_ARRAY } from 'constants/dbEnums';
import { COMMERCIAL_PROPERTY_ARRAY } from 'constants/dbEnums';
import { CREATE_USER } from 'constants/endpoints';
import { CREATE_COMPANY } from 'constants/endpoints';
import { BUILDERS_LISTING_API } from 'constants/endpoints';
import { BROKER_GROUP_API } from 'constants/endpoints';
import { PROPERTY_COLLECTIONS } from 'constants/dbEnums';
import { PROJECT_PROPERTY_TYPE } from 'constants/dbEnums';
import { REQUIREMENT_TYPE } from 'constants/dbEnums';
import { AD_TYPE_TAGS } from 'constants/dbEnums';
import { USER_ROLES } from 'constants/dbEnums';
import { showToast } from 'components/toast/Toast';

export const formatAdsTableData = (data) => {
  return data.map((item) => {
    let propertyType = PROPERTY_TYPE[item.property_type] || '-';
    if (item.custom_property_type) {
      propertyType = `${propertyType} / ${item.custom_property_type}`;
    }

    return {
      owner_email: item?.owner?.email || '-',
      owner_phone: item.owner?.phone || '-',
      collection_type: TRANSACTION_TYPE[item.collection_type] || '-',
      ad_type: AD_TYPE[item.ad_type] || '-',
      property_type: propertyType,
      created_at: `${formatDate(item.created_at)}, ${formatTime(item.created_at)}` || '-',
      slug_url: item.slug_url || '-',
      verified: item.verified,
      property_status: PROPERTY_STATUS[item.property_status] || '-',
      expires_on: formatDate(item.expires_on) || '-',
      actual_expiry: formatDate(item.actual_expiry) || '-',
      created_by: item?.created_by?.first_name ? `${item.created_by.first_name} ${item.created_by.last_name}` : '-',
      created_by_role: item?.created_by?.role,
      location: formatLocation(item.location) || '-',
      meta_title: item.meta_title || '-',
      meta_description: item?.meta_description || '-',
      listing_score: item.total_listing_score || 0,
      custom_listing_score: item.custom_listing_score || 0,
      _id: item._id || '',
      sid: item.sid || '-',
      stat_slug_url: item.slug_url || '-',
      user_id: item?.owner?._id || '',
      total_leads: item?.total_leads || '-',
      featured: item?.featured || false,
      last_activity_at: `${formatDate(item?.owner?.last_activity_at)}, ${formatTime(item?.owner?.last_activity_at)}` || '-',
      created_ip: item?.created_ip,
      comment: item?.comment,
      commented_by: item?.commented_by,
      commented_at: item?.commented_at ? `${formatDate(item.commented_at)}, ${formatTime(item.commented_at)}` : null,
      comment_updated_at: item?.comment_updated_at ? `${formatDate(item.comment_updated_at)}, ${formatTime(item.comment_updated_at)}` : null,
      classified_comment: item?.owner?.classified_comment,
      classified_primary_role: item?.owner?.classified_primary_role,
      contact_view_limit_exhausted: item?.contact_view_limit_exhausted,
    };
  });
};

export const formatJobApplicationData = (data) => {
  return data.map((item) => ({
    email: item.email || '-',
    phone: item.phone || '-',
    status: JOB_APPLICATION_STATUS[item.status] || '-',
    resume: item.resume || '-',
    job_id: item.job_id || '-',
    job_title: item.job_title || '-',
    answer: item.answer || '',
    comment: item.comment || '-',
    skills: item.skills || '-',
    education: item.education || '-',
    passout_year: item.passout_year || '-',
    current_location: item.current_location || '-',
    work_type_preference: item.work_type_preference || '-',
    experience: item.experience || '-',
    name: [`${item.first_name} ${item.last_name}`, false],
    created_at: `${formatDate(item.created_at)}, ${formatTime(item.created_at)}` || '-',
    last_reminder_email_sent_on: item.last_reminder_email_sent_on ? `${formatDate(item.last_reminder_email_sent_on)}, ${formatTime(item.last_reminder_email_sent_on)}` : '-',
    _id: item._id,
    dev_asignee: item.dev_asignee ?  `${item.dev_asignee.first_name} ${item.dev_asignee.last_name}` : '-',
    deadline: item.deadline ? `${formatDate(item.deadline)}, ${formatTime(item.deadline)}` : '-',
    last_comment_updated_on: item.last_comment_updated_on ? `${formatDate(item.last_comment_updated_on)}, ${formatTime(item.last_comment_updated_on)}` : '-'
  }));
};

export const formatUsersTableData = (data) => {
  return data?.map((user) => {
    return {
      _id: user._id,
      name: `${user.first_name} ${user.last_name}`,
      email: user.email ? user.email : '-',
      phone: user.phone,
      role: user?.role,
      gender: user?.gender,
      verified: user.verified ? 'Yes' : 'No',
      phone_verified: user.phone_verified ? 'Yes' : 'No',
      email_verified: user.email_verified ? 'Yes' : 'No',
      onboarding_completed: user.onboarding_completed ? 'Yes' : 'No',
      platform: user?.platform,
      plan: user.plan,
      active_properties: user.total_properties,
      created_at: `${formatDate(user.created_at)}, ${formatTime(user.created_at)}`,
      status: user?.phone_verified ? 'Verified' : 'Unverified',
      add_requirement: 'Add Requirement',
      actions: '-',
      slug_url: user.slug_url,
      username: user.username,
      plan_names: user.plan_names,
      is_deleted: user.is_deleted,
      comment: user.comment,
      classified_comment: user?.classified_comment,
      classified_primary_role: user?.classified_primary_role,
      classified_secondary_role: user?.classified_secondary_role,
      admin_verified: user?.admin_verified,
      number_private: user?.number_private,
      posting_limit_exhausted: user?.posting_limit_exhausted,
      contact_view_limit_exhausted: user?.contact_view_limit_exhausted,
      referrer: user?.referrer,
      last_activity_at: `${formatDate(user.last_activity_at)}, ${formatTime(user.last_activity_at)}`,
      signup_ip: user?.signup_ip,
      commented_by: user?.commented_by,
      commented_at: user?.commented_at ? `${formatDate(user.commented_at)}, ${formatTime(user.commented_at)}` : null,
      comment_updated_at: user?.comment_updated_at ? `${formatDate(user.comment_updated_at)}, ${formatTime(user.comment_updated_at)}` : null
    };
  });
};

export const formatUsersRequestTableData = (data) => {
  return data?.map((request) => {
    const locations = Array.isArray(request.location) ? request.location : [];
    const { first_name, last_name } = request.updated_by || {}
    return {
      _id: request._id,
      user_id: request.user_id,
      type: request.type,
      source: request.source,
      note: request.note || '-',
      status: request.status ? request.status.charAt(0).toUpperCase() + request.status.slice(1).toLowerCase() : '-',
      created_at: `${formatDate(request.created_at)}, ${formatTime(request.created_at)}`,
      updated_at: `${formatDate(request.updated_at)}, ${formatTime(request.updated_at)}`,
      user_data: {
        first_name: request.user_data?.first_name || '-',
        last_name: request.user_data?.last_name || '-',
        phone: request.user_data?.phone || '-',
        email: request.user_data?.email || '-',
        role: request.user_data?.role || '-',
      },
      property_type: request.property_type || '-',
      location: locations.map(loc => ({
        city: loc.city || '-',
        locality: loc.locality || '-',
        sub_locality: loc.sub_locality || '-',
        label: loc.label || '-',
      })),
      is_notified: request.is_notified,
      comment: request.comment || "-",
      updated_by: first_name ? `${first_name} ${last_name}` : "-",
    };
  });
};


export const formatUsersReportsTableData = (data) => {
  return data?.map((report) => ({
    ad_type: report.ad_type,
    report_type: report.report_type,
    description: report.description || '-',
    created_at: `${formatDate(report.created_at)}, ${formatTime(report.created_at)}`,
    updated_at: `${formatDate(report.updated_at)}, ${formatTime(report.updated_at)}`,
    user_data: {
      first_name: report.user_data?.first_name || '-',
      last_name: report.user_data?.last_name || '-',
      phone: report.user_data?.phone || '-',
      role: report.user_data?.role || '-',
    },
    ad_data: {
      slug_url: report.ad_data?.slug_url || '-',
    },
  }));
};


export const formatBuildersTableData = (data) => {
  return data?.map((builder) => {
    return {
      _id: builder._id,
      name: [
        `${builder?.user?.first_name}  ${builder?.user?.last_name}`,
        false,
      ],
      status: PROPERTY_STATUS[builder.status] || '-',
      experience: builder?.experience,
      company_name: builder?.company?.name,
      active_properties: builder?.total_properties,
      slug_url: builder?.user?.slug_url || '-',
      total_projects: builder?.total_projects,
    };
  });
};

export const formatAgentsTableData = (data) => {
  return data?.map((agent) => {
    return {
      _id: agent._id,
      name: [`${agent?.user?.first_name}  ${agent?.user?.last_name}`, false],
      email: agent?.company?.email || '-',
      status: PROPERTY_STATUS[agent.status] || '-',
      slug_url: agent?.user?.slug_url || '-',
      company_name: agent?.company?.name || '-',
    };
  });
};

export const formatProjectsTableData = (data) => {
  return data.map((item) => ({
    slug_url: item.slug_url,
    name: item.name,
    uid: item.uid,
    company_name: item?.builder_details?.company_details?.name,
    property_type: item?.property_type,
    project_status: item?.project_status,
    status: PROPERTY_STATUS[item?.status] || '-',
    address: `${item?.address?.locality},${item?.address?.city},${item?.address?.state}`,
  }));
};

export const isValidPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\d{10}$/;

  return phoneRegex.test(phoneNumber);
};

export const formatUserRequirementsTableData = (data) => {
  return data.map((item) => ({
    _id: item._id,
    user_id: item.user_id,
    property_type: item.property_type,
    ad_type: (
      <>
        {REQUIREMENT_TYPE[item.ad_type]}
        {item.shared_accommodation_interest && (
          <>
            {" - "}
            <strong>Shared accommodation</strong>
          </>
        )}
      </>
    ),
    comment: item.comment,
    address: [item?.location?.locality, item?.location?.city, item?.location?.state]
    .filter(Boolean)
    .join(', '),
    city: item?.location?.city,
    user_name: item?.user_data?.full_name,
    full_name: item.user_data?.full_name ? (
      <>
        {item.user_data.full_name} 
        {item.user_data.role !== USER_ROLE.OWNER && (
      <>
        {" + "}
        <strong>{USER_ROLES[item.user_data.role]}</strong>
      </>
    )}
      </>
    ) : null,
    phone: item.user_data?.phone,
    role: item.user_data?.role,
    email: item.user_data?.email,
    status: 'Add',
    ai_classified: item?.ai_classified,
    classified_comment: item?.user_data?.classified_comment,
    classified_primary_role: item?.user_data?.classified_primary_role,
    classified_secondary_role: item?.user_data?.classified_secondary_role,
    leads:  Array.isArray(item.leads) ? item.leads : '',
    created_at: `${formatDate(item.created_at)}, ${formatTime(item.created_at)}`,
    last_activity: `${formatDate(item.last_activity)}, ${formatTime(item.last_activity)}`,
    updated_at: `${formatDate(item.updated_at)}, ${formatTime(item.updated_at)}`,
    user_data: item.user_data,
    seen_by: Array.isArray(item.seen_by)
      ? item.seen_by
          .filter((seen) => seen && seen.first_name && seen.last_name)
          .map((seen) => `${seen.first_name} ${seen.last_name}`)
          .join(", ")
      : "",
    created_by: item.created_by
  }));
};

export const formatBrokerGroupTableData = (data) => {
  return data.map((item) => ({
    _id: item._id,
    name: item.name,
    property_type: item.property_type,
    ad_type: REQUIREMENT_TYPE[item.ad_type],
    comment: item.comment,
    address: [item?.location?.locality, item?.location?.city, item?.location?.state]
    .filter(Boolean)
    .join(', '),
    status: 'Update',
    total_members: item?.total_members
  }));
};

export const userColumnsData = {
  NAME: 'NAME',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ROLE: 'ROLE',
  VERIFIED: 'VERIFIED',
  ONBOARDING: 'ONBOARDING',
  PLATFORM: 'PLATFORM',
  PLAN: 'PLAN',
  ACTIVE_PROPERTIES: 'ACTIVE_PROPERTIES',
  CREATED_AT: 'CREATED_AT',
  ACTIONS: 'ACTIONS',
};

export const propertiesColumnsData = {
  SLUG: 'SLUG',
  SID: 'SID',
  OWNER_EMAIL: 'OWNER EMAIL',

  OWNER: 'OWNER',

  TRANSACTION_TYPE: 'TRANSACTION TYPE',

  AD_TYPE: 'AD TYPE',

  PROPERTY_TYPE: 'PROPERTY TYPE',

  POSTED_ON: 'POSTED ON',

  PROPERTY_VERIFIED: 'PROPERTY VERIFIED',

  PROPERTY_STATUS: 'PROPERTY STATUS',

  EXPIRES_ON: 'EXPIRES ON',

  LOCATION: 'LOCATION',

  ACTIONS: 'ACTIONS',

  META_TITLE: 'META TITLE',

  META_DESCRIPTION: 'META DESCRIPTION',

  LISTING_SCORE: 'LISTING SCORE',
};

export const buildersColumnsData = {
  NAME: 'NAME',
  STATUS: 'STATUS',
  VERIFIED: 'VERIFIED',
  EXPERIENCE: 'EXPERIENCE',
  COMPANY_NAME: 'COMPANY NAME',
  ACTIONS: 'ACTIONS',
  SLUG: 'SLUG',
};

export const getFilterFromLocalStorage = (key) => {
  return JSON.parse(localStorage.getItem(key));
};

export const setFilterToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const updateFilterInLocalStorage = (key, updates) => {
  const existingFilters = JSON.parse(localStorage.getItem(key)) || {};

  const updatedFilters = { ...existingFilters, ...updates };

  localStorage.setItem(key, JSON.stringify(updatedFilters));
};

export const ENTITY_FILTER_TYPES = {
  REQUEST_FILTER:'requestFilters',
  USERS_FILTER: 'userFilters',
  BUILDERS_FILTER: 'builderFilters',
  ADS_FILTER: 'adsFilters',
  AGENTS_FILTER: 'agentFilters',
  ADS_PAGE_SIZE: 'adsPageSize',
  USERS_PAGE_SIZE: 'usersPageSize',
  REQUEST_PAGE_SIZE: 'requestPageSize',
  BUILDERS_PAGE_SIZE: 'buildersPageSize',
  AGENTS_PAGE_SIZE: 'agentsPageSize',
  ADS_DATE_RANGE: 'adsDateRange',
  USERS_DATE_RANGE: 'usersDateRange',
  BUILDERS_DATE_RANGE: 'buildersDateRange',
  AGENTS_DATE_RANGE: 'agentsDateRange',
  DASHBOARD_ADS_DATE_RANGE: 'dashboardAdsDateRange ',
  PROJECTS_FILTER: 'projectsFilter',
  PROJECTS_DATE_RANGE: 'projectsDateRange',
  PROJECTS_PAGE_SIZE: 'projectsPageSize',
  USER_REQUIREMENTS_FILTER: 'userRequirementsFilter',
  USER_REQUIREMENTS_PAGE_SIZE: 'userRequirementsPageSize',
  USER_REQUIREMENTS_DATE_RANGE: 'userRequirementsDateRange',
  ACTIVITY_PAGE_SIZE: 'activityPageSize',
  ACTIVITY_FILTER: 'activityFilter',
  SUBSCRIPTION_FILTER : 'subscriptionsFilter',
  SUBSCRIPTION_DATE_RANGE: 'subscriptionsDateRange',
  SUBSCRIPTION_PAGE_SIZE: 'subscriptionsPageSize',
  ORDER_DATE_RANGE:'orderDateRange',
  ORDER_FILTER:'orderFilter',
  ORDER_PAGE_SIZE:'orderPageSize',
  PLAN_DATE_RANGE:'planDataRange',
  PLAN_FILTER:'planFilter',
  USER_USAGE_FILTER:'userUsageFilter',
  USER_USAGE_DATE_RANGE:'userUsageDataRange',
  USER_USAGE_PAGE_SIZE:'userUsagePageSize',
  USER_USAGE_ATTEMPTS_FILTER:'userUsageAttemptsFilter'
};

export const ENTITY_COLUMNS_TYPES = {
  REQUESTS_COLUMNS:'requestsColumns',
  FEEDBACKS_COLUMNS:'feedbacksColumns',
  USERS_COLUMNS: 'usersColumns',
  BUILDERS_COLUMNS: 'buildersColumns',
  ADS_COLUMNS: 'adsColumns',
  AGENTS_COLUMNS: 'agentsColumns',
  PROJECTS_COLUMNS: 'projectsColumns',
  USER_REQUIREMENTS_COLUMNS: 'userRequirementsColumns',
  REPORTS_COLUMNS: 'reportsColumns',
  LOCALITY_OVERVIEW_COLUMNS: 'localityOverviewColumns', 
  SUBSCRIPTIONS_COLUMNS:'subscriptionColumn',
  ORDER_COLUMNS:'orderColumn',
  FEATURES_LISTING_COLUMNS:'featureLisitingColumn',
  USER_USAGE_COLUMNS:'userUsageColumn',
  VIEW_NUMBER_COLUMNS:'viewNUmberUsageColumn'
};

export const CustomIcon = createIcon({
  displayName: 'CustomIcon',
  viewBox: '0 0 24 24',
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="3" x2="9" y2="21" />
      <line x1="15" y1="3" x2="15" y2="21" />
    </g>
  ),
});

export const getOneMonthFromToday = () => {
  const nextMonth = new Date();
  nextMonth.setMonth(nextMonth.getMonth() + 1);
  return nextMonth.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
};

export function areAllStatusesSame(statusArray) {
  return statusArray?.every((status) => status === statusArray[0]);
}

export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const formatDateToDDMMYYYY = (inputDate) => {
  if (!inputDate) return '';

  let date;

  if (typeof inputDate === 'string' || typeof inputDate === 'number') {
    date = new Date(inputDate);
  } else if (inputDate instanceof Date) {
    date = inputDate;
  } else {
    return 'Invalid date';
  }

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  // Format the date
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formatDateToMMDDYYYY = (inputDate) => {
  if (!inputDate) return '';

  let date;

  if (typeof inputDate === 'string' || typeof inputDate === 'number') {
    date = new Date(inputDate);
  } else if (inputDate instanceof Date) {
    date = inputDate;
  } else {
    return 'Invalid date';
  }

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  // Format the date
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};

export const formatDateToDDMONTHNAMEYYYY = (inputDate) => {
  if (!inputDate) return 'Not selected';

  let date;

  // Handle different types of input
  if (typeof inputDate === 'string' || typeof inputDate === 'number') {
    date = new Date(inputDate);
  } else if (inputDate instanceof Date) {
    date = inputDate;
  } else {
    return 'Invalid date';
  }

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return 'Invalid date';
  }

  const day = String(date?.getDate())?.padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = String(date.getFullYear()).slice(2);

  return `${day}-${month}-${year}`;
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'paid':
      return { colorScheme: 'orange' };
    case 'pending':
      return { colorScheme: 'yellow' };
    case 'created':
    case 'Fulfilled':
    case 'captured':
      return { colorScheme: 'green' };
    case 'failed':
    case 'deleted':
    case 'Ignored':
      return { colorScheme: 'red' };
    case 'Pending':
      return { colorScheme: 'orange' };
    case 'Expired':
    case 'Rejected':
      return { colorScheme: 'red' };
    case 'Deleted':
    case 'Inactive':
      return { colorScheme: 'gray' };
    case 'Active':
    case 'Shortlisted':
      return { colorScheme: 'green' };
    case 'YES':
      return {colorScheme: 'green'};
    case 'NO':
      return {colorScheme: 'gray'};
    case 'Owner':
    case 'Reviewed':
      return { colorScheme: 'blue' };
    case 'Agent':
      return { colorScheme: 'purple' };
    case 'Builder':
      return { colorScheme: 'teal' };
    case 'Admin':
      return { colorScheme: 'pink' };
    case 'Freemium':
      return { colorScheme: 'yellow' };
    case 'Premium':
      return { colorScheme: 'cyan' };
    case 'Hexa Premium':
      return { customColor: 'purple' }; // Custom color
    case 'Need To Complete Assignment':
      return { colorScheme: 'yellow' }; // Custom color
    case 'Assignment Submitted':
      return { colorScheme: 'cyan' }; // Custom color
    case 'Assignment Submitted':
      return { colorScheme: 'purple' }; // Custom color
    case 'Marketing Admin':
      return { colorScheme: 'cyan' };
    case 'Bloging Admin':
      return { colorScheme: 'yellow' };
    case 'Co_Living' :
      return { colorScheme: 'red' };
    default:
      return { colorScheme: 'gray' };
  }
};

export function createHandleRowSelect(key) {
  return (row, setSelectedRowsData, selectedRowsData) => {
    const findData = selectedRowsData.find((item) => item[key] === row[key]);

    setSelectedRowsData((prev) => {
      if (findData) {
        return prev.filter((item) => item[key] !== findData[key]);
      } else {
        return [...prev, row];
      }
    });
  };
}

const excluded = ['Rent', 'Sell'];
export const transformedTotalAdsDataFn = (dashboardData) => {
  // Transform nested data
  const nestedData = Object.entries(dashboardData)
    .map(([key, value]) => {
      if (typeof value === 'object') {
        return {
          type: key.charAt(0).toUpperCase() + key.slice(1),
          total: value.total,
          active: value.active,
          pending: value.pending,
          expired: value.expired,
          deleted: value.deleted,
          rejected: value.rejected,
          inactive: value.inactive,
        };
      }
      return null;
    })
    .filter(Boolean)
    .filter((item) => (excluded.includes(item.type) ? false : true));

  return [...nestedData];
};

export const transformedActiveAdsDataFn = (response) => {
  const { rent = {}, sell = {} } = response;

  const allKeys = new Set([...Object.keys(rent), ...Object.keys(sell)]);
  allKeys.delete('total');

  return Array.from(allKeys).map((type) => ({
    type: PROPERTY_TYPE[type] || type,
    rent: rent[type] || 0,
    sell: sell[type] || 0,
    total_ads: (rent[type] || 0) + (sell[type] || 0),
  }));
};

export const transformUserData = (data) => {
  return [
    {
      user_type: 'Agents',
      active: data?.agents?.active,
      inactive: data?.agents?.inactive,
      pending_verification: data?.agents?.pending_verification,
      rejected: data?.agents?.rejected,
    },
    {
      user_type: 'Builders',
      active: data?.builders?.active,
      inactive: data?.builders?.inactive,
      pending_verification: data?.builders?.pending_verification,
      rejected: data?.builders?.rejected,
    },
    {
      user_type: 'Projects',
      active: data?.projects?.active,
      inactive: data?.projects?.inactive,
      pending_verification: data?.projects?.pending_verification,
      rejected: data?.projects?.rejected,
    },
  ];
};

export const formatDateToMonth = (dateString) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };

  return date.toLocaleDateString('en-US', options).replace(/,/, '');
};

export const getScoreCardDetails = (score) => {
  let listingScoreColor = { track: '#808080', filled: '#404040' };
  if (score >= 90)
    listingScoreColor = { track: '#178C0C33', filled: '#178C0C' };
  else if (score >= 65)
    listingScoreColor = { track: '#FFEAD5', filled: '#F57C00' };
  else listingScoreColor = { track: '#C7161C33', filled: '#C7161C' };

  let listingScoreText = {
    text: 'Listing Score',
    subText:
      'Increase listing score by adding more details about this property.',
  };
  if (score >= 90)
    listingScoreText = {
      text: 'Your Listing score is Excellent',
      subText:
        'Congrats on a good score! Keep it up with your upcoming listing.',
    };
  else if (score >= 65)
    listingScoreText = {
      text: 'Your Listing score is Average',
      subText:
        'Enhance your listing with more details and Images for better results.',
    };
  else
    listingScoreText = {
      text: 'Your Listing score is Low',
      subText:
        'Improve your listing score! Add more details and photos for better visibility.',
    };

  return { listingScoreColor, listingScoreText };
};


export const LEAD_ACTION={
  bookmark:'Bookmark',
  page_view:'Viewed',
  view_number:"View Number",
  call:"Call",
  requested_callback:"Requested Callback",
  requested_photo:"Requested Photo"
}


export const FILTER_LEAD_ACTION={
  bookmark:'bookmark',
  page_view:'page_view',
  view_number:"view_number",
  call:"call",
  requested_callback:"requested_callback",
  requested_photo:"requested_photo"
}

export const shortRandomIdGenerator = (length = 6)=>{
  const sid = randomstring.generate({
      length,
      charset: 'alphanumeric',
      capitalization: 'uppercase',
      readable: true
  });
  return sid;
}

export const createMetaTitle = (name, address, propertyType = null) => {
  const MAX_LENGTH = 60;
  const propertyTypesTags = propertyType
    .map((type) => PROPERTY_TYPE_META_TAGS[type] || "")
    .filter((tag) => tag)
    .join(" ");
  let metaTitle = `${name}${address.city ? " " + address.city : ""}`;
  if (metaTitle.length < MAX_LENGTH && address?.locality) {
    metaTitle = `${name} ${address.locality} ${address.city || ""}`;
  }
  if (metaTitle.length < MAX_LENGTH && propertyType) {
    metaTitle = `${metaTitle} | ${propertyTypesTags}`;
  }
  return metaTitle;
};

export const createMetaDescription = (formData) => {
  const { name = "", property_type = [], address = {}, brochure = false, floorPlanAndPricing = [], amenities = [] } = formData;

  const propertyTypesTags = property_type
  .map((type) => PROPERTY_TYPE_META_TAGS[type] || "")
  .filter((tag) => tag)
  .join(" ");
  let metaDescription = '';
  
  metaDescription += `${name} ${propertyTypesTags}`;
  if (address && address.locality) {
    metaDescription += ` in ${address.locality}`;
  }
  if (brochure) {
    metaDescription += ' – Download brochures, ';
  }
  const hasRentPrice = floorPlanAndPricing.some(item => item.rentPrice);
  const hasSellingPrice = floorPlanAndPricing.some(item => item.sellingPrice);

  if (hasRentPrice || hasSellingPrice) {
    metaDescription += 'view prices, ';
  }

  if (hasRentPrice || hasSellingPrice) {
    metaDescription += 'explore floor plans on our site. ';
  }

  if (amenities.length > 0) {
    metaDescription += `With top amenities}.`;
  }

  metaDescription = metaDescription.replace(/,\s*$/, '');

  if (metaDescription.length > 160) {
    metaDescription = metaDescription.substring(0, 157) + '...';
  }
  return metaDescription;
};

export function renameSlugUrl(slugUrl, newName) {
  const formattedName = newName.toLowerCase().replace(/\s+/g, '-');
  let parts;

  if (slugUrl?.includes('-buid-')) {
    parts = slugUrl?.split('-buid-');
  } else if (slugUrl?.includes('-agentid-')) {
    parts = slugUrl?.split('-agentid-');
  } else {
    throw new Error('Invalid slug format');
  }
  
  if (parts?.length !== 2) {
      throw new Error('Invalid slug format');
  }
  const identifier = slugUrl.includes('-buid-') ? '-buid-' : '-agentid-';
  const newSlug = `${formattedName}${identifier}${parts[1]}`;
  return newSlug;
}

export function useQueryParams() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  
  return {
    propertyId: queryParams.get('id') || null,
    collectionType: queryParams.get('type') || null,
    propertyTypeFromQuery: queryParams.get('property_type') || null,
    ownerId: queryParams.get('owner_id') || null,
    companyName: queryParams.get('company_name') || null,
    builderId: queryParams.get('builder_id') || null,
    slugUrl: queryParams.get('slug_url') || null,
    agentId: queryParams.get('agent_id') || null,
    subId: queryParams.get('sub_id') || null,
    ord_id: queryParams.get('order_id') || null,
    is_custom: queryParams.get('is_custom') || null
  };
}
export const roleBadgeColor = (role) => {
  switch (role) {
      case USER_ROLE.ADMIN:
      case USER_ROLE.MARKETING_ADMIN:
      case USER_ROLE.HR_ADMIN:
          return "red"
      case USER_ROLE.OWNER:
          return "green"
      case USER_ROLE.AGENT_DEALER:
          return "purple"
      case USER_ROLE.BUILDER:
          return "teal"
      case USER_ROLE.CO_LIVING:
          return "#F16767"
      case USER_ROLE.BLOGING_ADMIN:
          return "#FCB454"
      default:
          return "gray"
  }
}

export const truncateString = (str, num = 20) => {
  if (str?.length > num) return str.slice(0, num) + "...";
  return str || "-";
}

export const createValueLabelArray = (key) => {
  return [
    { value: "true", label: `${key}` }
  ];
};

export const getDataFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const getTopCities =async () => {
  const storedCities = getDataFromLocalStorage("topCities");
  if (storedCities) {
    return storedCities;
  } else {
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}${STATIC_CONTENT_DATA_API("/cities.json")}`;
      const response = await axios.get(url);
      const data = response?.data.data;
      localStorage.setItem("topCities", JSON.stringify(data));
      return data;
    } catch (error) {
      console.error("Error fetching cities:", error);
      throw error;
    }
  }
};

export const getTagsForSelectedInput = (selectedTypes) => {
  let tags = {};

  if (selectedTypes?.includes("residential_property")) {
    RESIDENTIAL_PROPERTY_ARRAY.forEach(tag => {
      tags[tag.id] = tag.name;
    });
  }

  if (selectedTypes?.includes("commercial_property")) {
    COMMERCIAL_PROPERTY_ARRAY.forEach(tag => {
      tags[tag.id] = tag.name;
    });
  }

  if (selectedTypes?.includes(PROPERTY_COLLECTIONS.PG)) {
    tags[PROPERTY_COLLECTIONS.PG] = PROPERTY_COLLECTIONS.PG;
  }

  return tags;
};
 
export const API_ENDPOINTS = {
  user: CREATE_USER,
  company: CREATE_COMPANY,
  builder: BUILDERS_LISTING_API,
  brokerGroup: BROKER_GROUP_API
};

export const PROPERTY_TYPE_OPTIONS = getTagsForSelectedInput([
  PROJECT_PROPERTY_TYPE.RESIDENTIAL_PROPERTY,
  PROJECT_PROPERTY_TYPE.COMMERCIAL_PROPERTY,
  PROPERTY_COLLECTIONS.PG
]);

export const handleApiRequest = async ({ apiCall, payload, url, method }) => {
  try {
    const response = await apiCall[method](url, payload);
    if (response) {
      showToast({
        message: response.data.message,
        success: true,
        customStyle: {
          background: "#52c41a",
          color: "#fff",
          padding: "10px",
        },
      });
    }
    return response;
  } catch (error) {
    console.error("API request error", error);
    showToast({
      message: error?.response?.data?.error?.message
      ? error?.response?.data?.error?.message
      : error?.response?.data?.error,
      success: false,
      customStyle: {
        background: "#F24052",
        color: "#fff",
        padding: "10px",
      },
    });
    throw error?.response?.data?.error?.message
    ? error?.response?.data?.error?.message
    : error?.response?.data?.error;
  }
};

export const convertToIdNameArray = (tagsObject) => {
  return Object.entries(tagsObject).map(([id, name]) => ({ id, name }));
};

export const formatUsersFeedbackTableData = (data) => {
  return data?.map((feedback) => ({
    _id: feedback._id,
    user_id: feedback.user_id,
    feedback_type: feedback.feedback_type,
    feedback: feedback.feedback || '-',
    created_at: `${formatDate(feedback.created_at)}, ${formatTime(feedback.created_at)}`,
    user_data: {
      first_name: feedback.user_data?.first_name || '-',
      last_name: feedback.user_data?.last_name || '-',
      phone: feedback.user_data?.phone || '-',
      email: feedback.user_data?.email || '-',
      role: feedback.user_data?.role || '-',
    },
  }));
};


export const formatLocalityOverviewData = (data) => {
  return data?.map((overview) => ({
    _id: overview._id,
    location_slug: overview.location_slug,
    is_editable: overview.is_editable,
    title: overview.title,
    created_by: {
      first_name: overview.created_by?.first_name || '-',
      last_name: overview.created_by?.last_name || '-',
      phone: overview.created_by?.phone || '-',
    },
  }));
};

export const formatSubscriptionsTableData = (data) => {
  // Check if data is undefined or null, return an empty array if so
  if (!data) return [];

  return data.map((subscription) => {
    // Safely access nested properties with optional chaining and provide default values
     const capitalize = (str) => {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };
    const paid_amount = Number(subscription?.amount ?? subscription?.payment_data?.amount ?? 0) || 0;
    const commission = subscription?.sales_person_data?._id ? paid_amount * 0.1 : 0;
    return {
      _id: subscription?._id || '-',
      user_email: subscription?.user_data?.email || '-',
      category:subscription?.plan_data?.category || '-',
      plan_name: subscription?.plan_data?.name + (subscription?.plan_data?.type?(" - "+subscription?.plan_data?.type)?.toUpperCase():"" )|| '-',
      status: subscription?.status || '-',
      start_date: subscription?.start_date ? `${formatDate(subscription.start_date)} ${formatTime(subscription.start_date)}`: '-',
      end_date: subscription?.end_date ? `${formatDate(subscription.end_date)} ${formatTime(subscription.end_date)}` : '-',
      created_at: subscription?.created_at
        ? `${formatDate(subscription.created_at)}, ${formatTime(subscription.created_at)}`
        : '-',
       user_first_name: [
        capitalize(subscription?.user_data?.first_name),
        capitalize(subscription?.user_data?.last_name),
        (subscription?.user_data?.role)?(" + "+subscription?.user_data?.role).toUpperCase():'-'
      ].filter(Boolean).join(' ') || '-',
      user_phone: subscription?.user_data?.phone || '-',
      created_by: subscription?.created_by,
      admin_data: subscription?.admin_data,
      sales_person_data: subscription?.sales_person_data,
      paid_amount,
      commission,
      comment: subscription?.comment,
      commented_by: subscription?.commented_by,
      commented_at: subscription?.commented_at
        ? `${formatDate(subscription.commented_at)}, ${formatTime(subscription.commented_at)}`
        : null,
      comment_updated_at: subscription?.comment_updated_at
        ? `${formatDate(subscription.comment_updated_at)}, ${formatTime(subscription.comment_updated_at)}`
        : null,
      created_ip: subscription?.created_ip,
      actions: 'Manage', // Placeholder for any actions you want to associate with each subscription
    };
  });
};

export const formatFeaturesListingData = (data) => {
  // Check if data is undefined or null, return an empty array if so
  if (!data) return [];

  return data.map((feature) => {
    // Safely access properties with optional chaining and provide default values
    return {
      _id: feature?._id || '-',
      name: feature?.name || '-',
      key: feature?.key || '-',
      description: feature?.description || '-',
      created_at: feature?.created_at
        ? `${formatDate(feature.created_at)}, ${formatTime(feature.created_at)}`
        : '-',
      updated_at: feature?.updated_at
        ? `${formatDate(feature.updated_at)}, ${formatTime(feature.updated_at)}`
        : '-',
    };
  });
};


export const LIMIT_UNITS = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  PLAN: "plan",
  UNLIMITED: "unlimited"
};
export const PLAN_USER_TYPES = {
  TENANT: "tenant",
  BUYER: "buyer",
  LANDLORD: "landlord",
  SELLER: "seller",
  AGENT: "agent",
  PG_OWNER: "pg_owner",
  CO_LIVING: "co_living",
}
export const PLAN_CATEGORY = {
  USER: "user",
  AD: "ad",
}

export const PLAN_TYPE={
  pro:"Pro",
  pro_plus:"Pro_Plus"
}